import React from "react";
import ReactDOM from "react-dom";
import "./scss/index.scss";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
// import "../node_modules/font-awesome/css/font-awesome.min.css";

ReactDOM.render(<App />, document.getElementById("root"));
